<template>
  <div>
    <SortableContainer :serverUrl="serverUrl"></SortableContainer>
  </div>
</template>




<script>
import { BaseVue } from "@/mixin/index";
import { SortableContainer } from "@/core/container/";

export default {
  name: "StudyClassTypeLocation",
  
  mixins: [BaseVue],
  
  components: {
    SortableContainer
  },
  
  data() {
    return {
      serverUrl: "/api/manager/studyclasstype"
    };
  },
  
  
  mounted() {
    // 组件挂载后的逻辑
  }
};
</script>

<style scoped>
</style>